import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  border-radius: 100px;\n  box-shadow: ", ";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transform: translateX(calc(", "%));\n  transition: all 250ms ease-in-out;\n  width: calc((100% / ", "));\n  z-index: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  font-weight: 600;\n  height: 100%;\n  justify-content: center;\n  outline: none;\n  text-align: center;\n  transform: translate3d(0, 0, 0);\n  width: 100%;\n  z-index: 2;\n  transition: color 150ms ease-in-out, transform 150ms linear;\n\n  &:focus {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  &:active {\n    opacity: 1;\n    transform: scale(0.95);\n  }\n\n  &:hover {\n    opacity: 1;\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 99px;\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  height: 38px;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n\n  @media screen and (max-width: ", "px) {\n    font-size: 12px;\n    height: 38px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 99px;\n  padding: 3px;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, withPropsOnChange } from 'recompose';
import { TouchableOpacity } from '../TouchableOpacity';
import styled, { withTheme } from '../utils/styling/styled-components';
import { PILL } from '../utils/testing/TestIDs';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.ivory;
});
var MarkerContainer = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.breakpoints.md;
});
var Label = styled(TouchableOpacity)(_templateObject3(), function (props) {
  return props.color;
}, function (props) {
  return props.theme.colors.slate;
});
var Marker = styled(TouchableOpacity)(_templateObject4(), function (props) {
  return props.theme.shadows.smMedium;
}, function (props) {
  return 100 * props.offset;
}, function (props) {
  return props.widthDivisor;
});

var getLabelColor = function getLabelColor(props, index) {
  var _props$theme, _props$theme2;

  return props.selectedIndex === index ? props.selectedLabelColor || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colors.slate) : props.labelColor || ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.colors.stone);
};

var enhance = compose(withTheme, withPropsOnChange(['options'], function (_ref) {
  var options = _ref.options,
      onSelect = _ref.onSelect;
  return {
    // Note: Attach handler functions to the options
    options: options.map(function (option, index) {
      return _objectSpread(_objectSpread({}, option), {}, {
        handler: option.handler ? option.handler : function () {
          return onSelect(index);
        }
      });
    })
  };
}));
var PillNavigation = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/React.createElement(MarkerContainer, null, props.selectedIndex !== -1 && /*#__PURE__*/React.createElement(Marker, {
    offset: props.selectedIndex,
    widthDivisor: props.options.length
  }), props.options.map(function (_ref2, index) {
    var id = _ref2.id,
        text = _ref2.text,
        handler = _ref2.handler;
    return /*#__PURE__*/React.createElement(Label, {
      color: getLabelColor(props, index),
      "data-selected": props.selectedIndex === index,
      "data-testid": PILL,
      key: id,
      onClick: handler,
      role: 'button',
      tabIndex: 0
    }, text);
  })));
});
export { PillNavigation };